import { userManagementModule } from "../pages/userManagement";
import { applyMiddleware, combineReducers, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { getCompose } from "../common/devUtils/devAppBuilderRoutine";
import { Provider } from "react-redux";
import { createElement } from "react";
import { render } from "react-dom";

//TODO: add modules renderer
const modules = [userManagementModule];

// temporary render for single SubscriptionPreferencesPage from userManagementModule
(() => {
    const subscriptionPreferencesPage = userManagementModule.pages[0];

    const reducer = combineReducers({
        [userManagementModule.pathPrefix]: combineReducers({
            ...userManagementModule.commonPartReducer,
            [subscriptionPreferencesPage.pathPrefix]:
                subscriptionPreferencesPage.reducer,
        }),
    });

    const sagaMiddleware = createSagaMiddleware({
        context: { services: {} },
    });

    const composeEnhancers = getCompose();
    const store = createStore(
        reducer,
        composeEnhancers(applyMiddleware(sagaMiddleware))
    );

    sagaMiddleware.run(subscriptionPreferencesPage.saga);

    const root = document.getElementById("page-top");
    render(
        createElement(
            Provider,
            { store },
            createElement(subscriptionPreferencesPage.Component, { root })
        ),
        root
    );
})();
